import { render, staticRenderFns } from "./commentBox.vue?vue&type=template&id=1dcec8ec&"
import script from "./commentBox.vue?vue&type=script&lang=js&"
export * from "./commentBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports